import React from 'react';
import './companyManagement.scss';

import companyManagementDetail from './companyManagementDetail.js';

import {Logout} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import DataGrid, {
  Column,
 // Export,
  MasterDetail,
  Popup,
  Form,
  HeaderFilter,
  Lookup,
  Editing,
  Selection,
  Toolbar
} from 'devextreme-react/data-grid';

import { createStore } from 'devextreme-aspnet-data';
import { useState, useEffect } from "react";

import Button from 'devextreme-react/button';
import { Item} from 'devextreme-react/form';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa'
const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Commesse'

export default function CompanyManagement() {

  var manageDataGridRef = React.createRef();

  const [intermediari, setIntermediari] = useState({});
  const [currentRow, setCurrentRow] = useState(1);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [anni, setAnni] = useState({});

  const [annoFilter, setAnnoFilter] = useState(0);
  const [intermediarioFilter, setIntermediarioFilter] = useState(210);

  const filterPayload = { 
    anno: annoFilter,
    intermediario: intermediarioFilter
  };

  const dateBoxOptions = {
    dateSerializationFormat: 'yyyy-MM-dd'
  };

  const notesEditorOptions = { height: 38 };
  
  const { user } = useAuth(); 

  if (!user) 
    Logout();
  
  const remoteDataSource = createStore({

    key: 'id',
    loadUrl: serviceUrl2 + '/FindCompanyManagement',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
  });

  useEffect(() => {

    const fetchData = async () => {

      const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

      const newServiceUrl9 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_AnniCommesse';
      var newUrl9 =  newServiceUrl9 + "/GetAction";

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response7 = await fetch(newUrl7,requestOptions);
        const json7 = await response7.json();
        console.log(json7);
        setIntermediari(json7);

        const response9 = await fetch(newUrl9);
        const json9 = await response9.json();
        console.log(json9);
        setAnni(json9);

      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);

  function onRowInserting(e) {
    e.data.createBy = user.name;
    e.data.management = 1;
  };

  function onRowUpdating(e) {
    e.newData.updateBy = user.name;
  };

  function refreshDataGrid() {
    manageDataGridRef.instance().refresh();
  }

  const addButtonOptions = {
    icon: 'plus',
    hint: 'Nuova Gestione'
  };


  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {
      setCurrentRow(data.id);
      setIsRowSelected(true);

      //console.log("SELECTED: " + e.currentSelectedRowKeys);
      //setCurrentId(e.currentSelectedRowKeys);

    } else{
      setIsRowSelected(false);
    }
  }

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Controllo gestione</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
          

        <DataGrid id="grid-container"
          ref={ref => manageDataGridRef = ref}
          className={'dx-card wide-card'}
          dataSource={remoteDataSource}
          showBorders={true}
          dateSerializationFormat= {'yyyy-MM-dd'}
          onSelectionChanged={onRowSelectionChanged}
          onRowUpdating={onRowUpdating}
          onRowInserting={onRowInserting}
          //onRowExpanded={onRowExpanded}
          //onEditingStart={onEditingStart}
          //onRowRemoving={onRowRemoving}
          //onEditorPreparing={onEditorPreparing}
          //onExporting={onExporting}
          //onCellPrepared={onCellPrepared}
        >
         

          <Toolbar>
          
            <Item name="addRowButton"  options={addButtonOptions} location="before"/>
            <Item location="before">
              <Button className="offer-toolbar"
                icon='refresh'
                hint='Aggiorna'
                onClick={refreshDataGrid} 
                />
            </Item>
           
            
            <Item name="searchPanel" className="offer-toolbar"/>
          
          </Toolbar>


          <HeaderFilter visible={true} />
          
          <Selection mode="single" />

          <Editing
            mode="popup"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true}
            useIcons={true}
          >
          
          <Popup title="Controllo gestione" showTitle={true} width={1200} height={780} />
            <Form>
           
              <Item itemType="group" caption="Dati Identificativi" colCount={4} colSpan={2}>
               
                <Item dataField="intermediarioId" colSpan={2} isRequired= "true"/>
                <Item dataField="nome"colSpan={2} />
                <Item dataField="dataInizio"colSpan={2} isRequired= "true"/>
                <Item dataField="dataFineEffettiva"colSpan={2} isRequired= "true"/>
                <Item
                  dataField="descrizione"
                  editorType="dxTextArea"
                  colSpan={4}
                  editorOptions={notesEditorOptions} />
               
                
          
 
              </Item>  
              
            </Form>
          </Editing>
              

          <Column dataField="id" visible={true} caption="#"width={90}/>
          <Column dataField="codice" caption="Codice" width={110} visible={false}/>
          <Column dataField="intermediarioId" caption="Azienda"  visible={true}>
            <Lookup dataSource={intermediari} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="nome" caption="Nome" />
          <Column dataField="dataInizio" dataType="date" format= {'dd/MM/yyyy'} caption="Data inizio" width={130}/>
          <Column dataField="dataFineEffettiva" dataType="date" format= {'dd/MM/yyyy'} caption="Data Fine" width={130} />
          <Column dataField="descrizione" caption="Descrizione" visible={false}/>
  
          <MasterDetail
            enabled={true}
            component={companyManagementDetail}
          />
         
        </DataGrid>

        </div>
      </div>
    </React.Fragment>
  )
};

